<template>
    <dashboard-criticality-card
        title="Sağlık Raporu"
        :fields="fields"
        :provider="provider"
        :enabled-levels="enabledLevels"
        excel-file-name="Saglik_Raporu" />
</template>

<script>
import HealthReportApi from "@/api/health-report";
import DashboardCriticalityCard from "./DashboardCriticalityCard.vue";

export default {
    components: { DashboardCriticalityCard },
    props: {
        enabledLevels: { type: Array, default: null },
    },
    data() {
        return {
            fields: [
                { name: "Personel", key: "EmployeeFullName" },
                { name: "Sicil No", key: "RegistrationCode" },
                { name: "Başlangıç Tarihi", key: "StartDateStr" },
                { name: "Bitiş Tarihi", key: "EndDateStr" },
                { name: "Kalan Gün", key: "RemainingDate" },
            ],
        };
    },
    methods: {
        provider() {
            return HealthReportApi.Dashboard();
        },
    },
};
</script>
